let animation = bodymovin.loadAnimation({
  container: document.getElementById('lottie'),
  renderer: 'svg',
  loop: true,
  autoplay: false,
  path: '../omatsuri_loading.json' // jsonデータをファイルにして配置しておく(http経由じゃないと読めないかも)
});
animation.play()